import Box from '@mui/material/Box';
import { Trans } from 'react-i18next';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ProfileContext from './ProfileContext';

export default function() {
  return (
    <ProfileContext.Consumer>
      { context => {
        const handleClose = () => {
          context.setDialogOpen(false)
        }
        
        const handleDiscard = () => {
          context.onCloseDialog()
          context.dialogOpen = false
          context.editing = false
        }
        
        const handleSave = () => {
          context.update(context.formValues)
          .then(() => context.onCloseDialog())
        }

        return (
          <Dialog
            open={context.dialogOpen}
            onClose={handleClose}
            className="profile-dialog-card"
          >
            <Box sx={{margin: '43px 0'}}>
              <Box className="profile-dialog-title" sx={{marginBottom: '10px'}}>
                <Trans i18nKey={`screens.profile.sections.goingOutDialog.title`}></Trans>
              </Box>
              <Box className="profile-dialog-text" sx={{margin: '0 15% 45px'}}>
                <Trans i18nKey={`screens.profile.sections.goingOutDialog.detail`}></Trans>
              </Box>
              <Box sx={{display: 'flex', justifyContent: 'center', marginBottom: '29px'}}>
                <Button className="profile-dialog-save-button" onClick={handleSave}>
                    <Trans i18nKey={`screens.profile.sections.goingOutDialog.saveButton`}></Trans>
                </Button>
              </Box>
              <Box sx={{display: 'flex', justifyContent: 'center'}}>
                <Button className="profile-dialog-discard-button" onClick={handleDiscard}>
                    <Trans i18nKey={`screens.profile.sections.goingOutDialog.discardButton`}></Trans>
                </Button>
              </Box>
            </Box>
          </Dialog>
        )
      }}
    </ProfileContext.Consumer>
  )
}